module.exports = __webpack_public_path__ + "img/img59.26b1d2d9.svg";